export enum PricePart {
  CURRENCY = "currency",
  GROUP = "group",
  DECIMAL = "decimal",
}
